import styled from 'styled-components'
import breakpoint from 'components/breakpoint'
import ButtonText from 'components/button/ButtonText'

const getWidth = props => {
  if (props.biometric) {
    return '100%'
  }

  return props.icon ? 'calc(100% - 40px)' : '100%'
}

const StyledButtonText = styled(ButtonText)`
  ${breakpoint('landscape')`
     width: ${getWidth};
  `};
`

export default StyledButtonText
